import React, { useEffect, useState, useRef } from "react";
import LogoutButton from "../Buttons/logout";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardIcon from "../../Assets/Svg/dashboard";
import ProductIcon from "../../Assets/Svg/products";
import BillingIcon from "../../Assets/Svg/billing";
import InventoryIcon from "../../Assets/Svg/inventory";
import SalesIcon from "../../Assets/Svg/sales";
import PurchaseIcon from "../../Assets/Svg/purchase";
import CustomerIcon from "../../Assets/Svg/customer";
import SupplierIcon from "../../Assets/Svg/supplier";
import ReportIcon from "../../Assets/Svg/reports";
import ExpenseIcon from "../../Assets/Svg/expense";
import SettingIcon from "../../Assets/Svg/settings";
import ImportexpoertIcon from "../../Assets/Svg/importexport";
import FeatureLockWrapper from "../FeatureLocksWrapper";

const Sidebar = (props) => {
  let { body } = props;

  let navigate = useNavigate();
  let location = useLocation();

  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [isFocused, setIsFocused] = useState(false);
  const [isUnlocked, setIsUnlocked] = useState(false);

  const menuRefs = useRef([]);
  const sidebarRef = useRef(null);

  useEffect(() => {
    const fetchFeatureUnlocks = async () => {
      const sales = await FeatureLockWrapper.isFeatureUnlocked("wholesale_billing");
      setIsUnlocked(sales);
    };
    fetchFeatureUnlocks();
  }, []);


  const menu = [
    {
      icon: <DashboardIcon />,
      name: "Dashboard",
      path: "/app/dashboard",
    },
    {
      icon: <ProductIcon />,
      name: "Products",
      path: "/app/products",
    },
    {
      icon: <InventoryIcon />,
      name: "Inventory",
      path: "/app/inventory",
    },
    {
      icon: <BillingIcon />,
      name: "Billing",
      path: "/app/billing",
    },
    ...(isUnlocked ? [{
      icon: <SalesIcon />,
      name: "Sales",
      path: "/app/sales",
    }] : []),
    {
      icon: <PurchaseIcon />,
      name: "Purchases",
      path: "/app/purchases",
    },
    {
      icon: <ExpenseIcon />,
      name: "Expenses",
      path: "/app/expenses",
    },
    {
      icon: <CustomerIcon />,
      name: "Customers",
      path: "/app/customers",
    },
    {
      icon: <SupplierIcon />,
      name: "Suppliers",
      path: "/app/suppliers",
    },
    {
      icon: <ReportIcon />,
      name: "Reports",
      path: "/app/reports",
    },
    {
      icon: <ImportexpoertIcon />,
      name: "Import-Export",
      path: "/app/importexport",
    },
    {
      icon: <SettingIcon />,
      name: "Settings",
      path: "/app/settings",
    },
  ];

  const [data, setData] = useState(menu);

  useEffect(() => {
    if (body?.role) {
      let menu = [];
      if (body?.role == "SUPERADMIN") {
        setData([
          {
            icon: <DashboardIcon />,
            name: "Dashboard",
            path: "/app/dashboard",
          },
          {
            icon: <ProductIcon />,
            name: "Products",
            path: "/app/products",
          },
          {
            icon: <InventoryIcon />,
            name: "Inventory",
            path: "/app/inventory",
          },
          {
            icon: <BillingIcon />,
            name: "Billing",
            path: "/app/billing",
          },
          ...(isUnlocked ? [{
            icon: <SalesIcon />,
            name: "Sales",
            path: "/app/sales",
          }] : []),
          {
            icon: <PurchaseIcon />,
            name: "Purchases",
            path: "/app/purchases",
          },
          {
            icon: <ExpenseIcon />,
            name: "Expenses",
            path: "/app/expenses",
          },
          {
            icon: <CustomerIcon />,
            name: "Customers",
            path: "/app/customers",
          },
          {
            icon: <SupplierIcon />,
            name: "Suppliers",
            path: "/app/suppliers",
          },
          {
            icon: <ImportexpoertIcon />,
            name: "Import-Export",
            path: "/app/importexport",
          },
          {
            icon: <ReportIcon />,
            name: "Reports",
            path: "/app/reports",
          },
          {
            icon: <SettingIcon />,
            name: "Settings",
            path: "/app/settings",
          },
        ]);
      } else {
        let options = [];
        data?.map((v) => {
          options?.push(v?.name);
        });

        body?.role?.details?.map((v, i) => {
          if (v?.view) {
            if (options?.includes?.(v?.name)) {
              let index = menu.push(data[options?.indexOf(v?.name)]);
            }
          }
        });

        setData(menu);
      }
    }
  }, [body, isUnlocked]);

  const handleKeyDown = (e) => {
    if (!isFocused) return;

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        const nextIndex = selectedIndex < data.length - 1 ? selectedIndex + 1 : 0;
        setSelectedIndex(nextIndex);
        navigate(data[nextIndex].path);

        setTimeout(() => {
          menuRefs.current[nextIndex]?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }, 10);
        break;

      case 'ArrowUp':
        e.preventDefault();
        const prevIndex = selectedIndex > 0 ? selectedIndex - 1 : data.length - 1;
        setSelectedIndex(prevIndex);
        navigate(data[prevIndex].path);

        setTimeout(() => {
          menuRefs.current[prevIndex]?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }, 10);
        break;

      case 'Escape':
        e.preventDefault();
        setSelectedIndex(-1);
        break;

      default:
        break;
    }
  };

  const handleMenuItemClick = (index, path) => {
    navigate(path);
    setSelectedIndex(index);
  };

  const handleMenuItemMouseEnter = (index) => {
    setSelectedIndex(index);
  };

  const handleSidebarMouseLeave = () => {
    setSelectedIndex(-1);
  };

  const handleSidebarMouseEnter = () => {
    setIsFocused(true);
    const currentIndex = data.findIndex(item =>
      location.pathname.includes(item.path)
    );
    if (currentIndex !== -1) {
      setSelectedIndex(currentIndex);
    }
  };

  const handleClickOutside = (e) => {
    if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
      setIsFocused(false);
      setSelectedIndex(-1);
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    document.addEventListener('mousedown', handleClickOutside);
    menuRefs.current = menuRefs.current.slice(0, data.length);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [data, selectedIndex, isFocused, navigate]);

  useEffect(() => {
    const currentIndex = data.findIndex(item =>
      location.pathname.includes(item.path)
    );
    setSelectedIndex(currentIndex);
  }, [data, location.pathname]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsFocused(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setData(menu);
  }, [isUnlocked]);

  return (
    <div
      ref={sidebarRef}
      className="border-r bg-white fixed left-0 top-0 bottom-0 z-50 w-64"
      onMouseEnter={handleSidebarMouseEnter}
      onMouseLeave={handleSidebarMouseLeave}
      tabIndex={-1}
    >
      <div className="p-4 overflow-y-auto h-full">
        <div className="mt-16">
          {data?.map((value, index) => {
            const isSelected = index === selectedIndex;
            const isActive = location?.pathname?.includes(value?.path);

            return (
              <div
                key={index}
                ref={el => menuRefs.current[index] = el}
                className={`
                  my-2 cursor-pointer rounded-lg transition-all duration-200
                  ${isActive
                    ? "!bg-[#07b553] !border-[#07b553]"
                    : isSelected
                      ? "bg-gray-100 border border-gray-300"
                      : "hover:bg-gray-50"
                  }
                `}
                onClick={() => handleMenuItemClick(index, value?.path)}
                onMouseEnter={() => handleMenuItemMouseEnter(index)}
              >
                <div
                  className={`
                    flex p-2 transition-colors duration-200
                    ${isActive
                      ? "text-white"
                      : isSelected
                        ? "text-[#07B553]"
                        : "text-[#353F4F] hover:text-[#07B553]"
                    }
                  `}
                >
                  <div className={isSelected && !isActive ? "transform scale-110" : ""}>
                    {value?.icon}
                  </div>
                  <div className="px-2 my-auto font-medium">
                    {value?.name}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="w-full absolute bottom-0 left-0">
        <LogoutButton />
      </div>
    </div>
  );
};

export default Sidebar;